import { render, staticRenderFns } from "./SaldosContas.vue?vue&type=template&id=2086c690&"
import script from "./SaldosContas.vue?vue&type=script&lang=js&"
export * from "./SaldosContas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports